(function (app) {

    app.provider("directoryApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        // GETs
                        service.get = function (directoryId) {
                            return crmApiGateway.get("/Directories/" + directoryId);
                        }

                        service.searchFiles = function (rootDirId, searchTerm) {
                            return crmApiGateway.getArray("/Directories/" + rootDirId + "/Search?q=" + searchTerm);
                        };

                        service.getChildren = function(directoryId) {
                            return crmApiGateway.getArray("/Directories/" + directoryId + "/Children");
                        }

                        service.getFiles = function (directoryId) {
                            return crmApiGateway.getArray("/Directories/" + directoryId + "/Files");
                        }

                        service.getPersonDirectory = function(personId) {
                            return crmApiGateway.get("/People/" + personId + "/RootDirectory");
                        }

                        service.getUserDirectory = function(userId) {
                            return crmApiGateway.get("/Users/" + userId + "/RootDirectory");
                        }

                        service.getPlanningDirectory = function(caseId) {
                            return crmApiGateway.get("/Cases/" + caseId + "/PlanningDirectory");
                        }

                        service.getInvestmentAccountDirectory = function(accountId) {
                            return crmApiGateway.get("/InvestmentAccounts/" + accountId + "/Directory");
                        }

                        service.getInsuranceAccountDirectory = function (accountId) {
                            return crmApiGateway.get("/InsuranceAccounts/" + accountId + "/Directory");
                        }

                        // PUTs
                        service.update = function (directoryId, directory) {
                            return crmApiGateway.put("/Directories/" + directoryId, directory);
                        }

                        service.updateParent = function (directoryId, directory) {
                            return crmApiGateway.put("/Directories/" + directoryId + "/Parent", directory);
                        }

                        // POSTs
                        service.create = function (directory) {
                            return crmApiGateway.post("/Directories", directory);
                        }

                        service.addFile = function(directoryId, file) {
                            return crmApiGateway.postFile("/Directories/" + directoryId + "/Files", file);
                        }

                        // DELETEs
                        service.delete = function (directoryId) {
                            return crmApiGateway.delete("/Directories/" + directoryId);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore: line